import { Component, OnInit, Input } from '@angular/core';

import { AppService } from 'src/app/app.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';

@Component({
    selector: 'app-signup-banner',
    templateUrl: './signup-banner.component.html',
    styleUrls: ['./signup-banner.component.scss'],
    standalone: false
})
export class SignupBannerComponent {
	@Input() _class;
	@Input() 'position' = 'banner';

	$storage: any;
	message;
	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
		public dialogsService: DialogsService,
	) {
		this.$storage = this.tabitPayService.$storage;
		this.message = this.appService.translate('_LOYALTY.banner_title');
	}
}
